import React, {useState} from 'react';
import {Button, DialogActions, FormControlLabel, Paper,} from "@mui/material";
import {BRCustomizedTooltip as Tooltip} from "../../accents/BRCustomizedTooltip";
import {Col, Row} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import {Dialog, DialogContent, DialogTitle, Switch} from "@material-ui/core";
import {useForm, } from "react-hook-form";
import Select from "react-select";
import {addSocialTemplates, updateSocialTemplates} from "../../../../actions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import BBIconQuickViewMagnifying from "../../../../assets/bbCustomIcons/BBIconQuickViewMagnifying";
import BBIconPaperClipThin from "../../../../assets/bbCustomIcons/BBIconPaperClipThin";
import BBIconHyperlink from "../../../../assets/bbCustomIcons/BBIconHyperlinkRound";

const AddNewSocialTemplate = ({viewMore=false, templateId=null})=>{

    const {templates, } = useSelector(({admin})=>admin);
    const dispatch = useDispatch();

    const [open, setOpen] = useState(false);
    const [editMode, setEditMode] = useState(!viewMore && !templateId);

    const template = templates && templateId && templates.templates && templates.templates[templateId];


    const defaultValues = {
        socialAccountId: null,
        subjectString: "",
        htmlMessage: "",
        plainTextMessage: "",
        statusId: null,
        socialThemeId: null,
        payloadTypeId: 0,
        payloadTemplate: null,
        technologyTypeId: null,
        hostingProviderId: null,
        vectorTypeId: null,
        entityToSendTo: null,

    }

    const { register, handleSubmit,watch, reset, setValue, control, formState: { errors } } = useForm({defaultValues});

    const [openForm, setOpenForm] = useState(false);

    const domains = templates && templates.domains;
    const accounts = templates && templates.accounts;
    const hostingProviders = templates && templates.hosting_providers;
    const statuses = templates && templates.statuses;
    const technologies = templates && templates.technologies;
    const themes = templates && templates.themes;
    const vectors = templates && templates.vectors;
    const payloadTemplates = templates && templates.payloadTemplates;

    // const [domainSelected, setDomainSelected] = useState(null);
    const [socialAccountId, setSocialAccountId] = useState(null);
    const [subjectString, setSubjectString] = useState("");
    const [htmlMessage, setHtmlMessage] = useState("");
    const [plainTextMessage, setPlainTextMessage] = useState("");
    const [statusId, setStatusId] = useState(null);
    const [socialThemeId, setSocialThemeId] = useState(null);
    const [payloadTypeId, setPayloadTypeId] = useState(0);
    const [payloadTemplate, setPayloadTemplate] = useState(null);
    const [senderName, setSenderName] = useState("");
    const [technologyTypeId, setTechnologyTypeId] = useState(null);
    const [hostingProviderId, setHostingProviderId] = useState(null);
    const [vectorTypeId, setVectorTypeId] = useState(null);
    const [statusSelected, setStatusSelected] = useState(null);
    const [entityToSendTo, setEntityToSendTo] = useState(null);

    const clearForm = () => {
        setSocialAccountId(null);
        setSubjectString("");
        setHtmlMessage("");
        setPlainTextMessage("");
        setSocialThemeId(null);
        setSocialThemeId(null);
        setPayloadTypeId(0);
        setPayloadTemplate(null);
        setSenderName("");
        setTechnologyTypeId(null);
        setHostingProviderId(null);
        setVectorTypeId(null);
        setStatusSelected(null);
        setEntityToSendTo(null);

        document.getElementById('addNewSocialTemplateForm').reset();
    }

    const onSubmit=(data)=>{

        if(!templateId && !viewMore){
            dispatch(addSocialTemplates(
                socialAccountId,
                subjectString,
                htmlMessage,
                plainTextMessage,
                statusId,
                socialThemeId,
                payloadTypeId,
                payloadTemplate,
                senderName,
                technologyTypeId,
                hostingProviderId,
                vectorTypeId,
                entityToSendTo,
            ));
            clearForm();
        } else{
            dispatch(updateSocialTemplates(templateId,
                {
                socialAccountId,
                    subjectString,
                    htmlMessage,
                    plainTextMessage,
                    statusId,
                    socialThemeId,
                    payloadTypeId,
                    payloadTemplate,
                    senderName,
                    technologyTypeId,
                    hostingProviderId,
                    vectorTypeId,
                    entityToSendTo,
            }
            ));
            setOpen(false);
        }



    }


    const accountsAsOptionsArray = accounts && Object.values(accounts).map((account)=>{
        return{
            ...account,
            label: <Tooltip title={account.sender_name}><p>{account.username}</p></Tooltip>,
            value: account.id,
        }
    })

    accountsAsOptionsArray && accountsAsOptionsArray.unshift({label: "None", value: null});


    const domainsAsOptionsArray = domains && Object.values(domains).map((domain)=>{
        return{
            ...domain,
            label: domain.domain,
            value: domain.id,
        }
    });

    const themesAsOptionsArray = themes && Object.values(themes).map((theme)=>{
        return{
            ...theme,
            label: <Tooltip title={theme.Description}><p>{theme.Name}</p></Tooltip>,
            value: theme.Id,
        }
    });

    themesAsOptionsArray && themesAsOptionsArray.unshift({label: "None", value: null});

    const statusAsOptionsArray = statuses && Object.values(statuses)
        .map((status)=>{
        return{
            ...status,
            label: <p>{status.name} : {status.description}</p>,
            value: status.id,
        }
    });

    statusAsOptionsArray && statusAsOptionsArray.unshift({label: "None", value: null});


    const payloadTemplateOptionsArray = payloadTemplates && Object.values(payloadTemplates)
        .map((payloadTemplate)=>{
        return{
            ...payloadTemplate,
            label: payloadTemplate.name,
            value: payloadTemplate.id,
        }
    });

    payloadTemplateOptionsArray && payloadTemplateOptionsArray.unshift({label: "None", value: null});

    const techTypesOptionsArray = technologies && Object.values(technologies)
        .map((techType)=>{
        return{
            ...techType,
            label: techType.name,
            value: techType.id,
        }
    });

    techTypesOptionsArray && techTypesOptionsArray.unshift({label: "None", value: null});

    const hostingProvidersOptionsArray = hostingProviders && Object.values(hostingProviders)
        .map((hostingProvider)=>{
        return {
            ...hostingProvider,
            label: hostingProvider.name,
            value: hostingProvider.id,
        }
    });

    hostingProvidersOptionsArray && hostingProvidersOptionsArray.unshift({label: "None", value: null});

    const associatedVectorOptionsArray = vectors && Object.values(vectors)
        .map((vector)=>{
        return{
            ...vector,
            label: <Tooltip title={vector.description}><p>{vector.name}</p></Tooltip> ,
            value: vector.id,
        }
    })

    associatedVectorOptionsArray && associatedVectorOptionsArray.unshift({label: "None", value: null});


// console.log("templates and templates.templates", templates, templates.templates)
    return(
        <div>
            {!viewMore && !templateId ?
                <Tooltip title={`Create a new phishing template.`}>
                <Button
                    variant={"outlined"}
                    // color={"default"}
                    onClick={()=>setOpen(true)}
                    className={"text-electric-blue"}>
                    Add New Template
                </Button>
            </Tooltip>
            : <IconButton onClick={()=> setOpen(true)}
                          variant={"contained"}
                          color={"primary"}>
                    <BBIconQuickViewMagnifying
                        style={{color: "black"}}/>
                </IconButton>}

            {open && <Dialog open={open}
                             fullScreen={false}
                             fullWidth={true}
                             maxWidth={"lg"}
                             className={"m-1 p-1 animated fadeIn animation-duration-6"}
                             aria-labelledby="form-dialog-title">

                <DialogTitle id="customized-dialog-title" >
                    <Row>
                        <Col lg={11}/>
                        <Col lg={1} className={"text-right align-self-center d-print-none"}>
                            <IconButton
                                onClick={()=>setOpen(false)}
                                className={"close"}>
                                <CloseIcon/>
                            </IconButton>
                        </Col>
                    </Row>
                </DialogTitle>
                <DialogContent>
                        <Paper style={{width: "100%", }}>
                            {viewMore && templateId &&
                                <Row>
                                    <Col>
                                        <FormControlLabel control={<Switch
                                            // disabled={isDisabled}
                                            label={"Enable Editing"}
                                            name={"editMode"}
                                            id={"editMode"}
                                            color={"primary"}
                                            clickable ={true}
                                            checked={editMode}
                                            size="medium"
                                            onClick={() => setEditMode(!editMode)}
                                            className={"align-self-center float-right"}
                                        />}
                                                          label={"Enable Editing"}
                                                            className={"float-right"}/>

                                    </Col>
                                </Row>}
                            <form id={"addNewSocialTemplateForm"} onSubmit={handleSubmit(onSubmit)}>
                                <div className={"card-header"}>
                                    <Row className={"text-center card-title"}>
                                        <Col>
                                            <label htmlFor={"subjectString"}>Email Subject:</label>
                                            {editMode
                                                ? <input
                                                id={"subjectString"}
                                                type={"text"}
                                                name={"subjectString"}
                                                defaultValue={template && template.subject ? template.subject : subjectString}
                                                required={!viewMore}
                                                onChange={(e)=>setSubjectString(e.target.value)}
                                                className="mt-1 p-2 my-sm-3 form-control"/>
                                            : <p>{template && template.subject ? template.subject : "--"}</p>}
                                        </Col>
                                        <Col>
                                            <label htmlFor={"senderName"}>Sender Name:</label>
                                            {editMode
                                                ? <input
                                                id={"senderName"}
                                                type={"text"}
                                                name={"senderName"}
                                                defaultValue={template && template.sender_name ? template.sender_name : senderName}
                                                required={!viewMore}
                                                onChange={(e)=>setSenderName(e.target.value)}
                                                className="mt-1 p-2 my-sm-3 form-control"/>
                                            : <p>{template && template.sender_name ? template.sender_name : "--"}</p>}
                                        </Col>
                                        <Col>
                                            <label htmlFor={"socialAccountId"}>Sent From:</label>
                                            {editMode
                                                ? <Select options={accountsAsOptionsArray}
                                                    className="mt-1 my-sm-3"
                                                    name={"socialAccountId"}
                                                    id={"socialAccountId"}
                                                    defaultValue={template
                                                    && template.social_account
                                                    && template.social_account.id
                                                        ? accountsAsOptionsArray.find(x => x.value === template.social_account.id)
                                                        : accountsAsOptionsArray[0]}
                                                    onChange={(e)=>setSocialAccountId(e.value)}
                                                // value={"socialAccountId"
                                            />
                                                : template
                                                && template.social_account
                                                && template.social_account.username
                                                && template.social_account.sender_name
                                                && <Tooltip title={template.social_account.sender_name}>
                                                    <p>
                                                        {template.social_account.username}
                                                    </p>
                                                </Tooltip>}

                                        </Col>
                                    </Row>
                                    <Row className={"text-center"}>
                                        <Col>
                                            <Row>
                                                <Col>
                                                    Payload Type:
                                                </Col>
                                            </Row>
                                            <Row className={"text-center"}>
                                                {editMode
                                                    ? <Col>
                                                    <label htmlFor={"1"}
                                                           className={"m-0 p-0"}>Download&nbsp;</label>
                                                    <input type={"radio"}
                                                           name={"payloadTypeId"}
                                                           className="mt-1 my-sm-3"
                                                           id={"1"}
                                                           value={1}
                                                           checked={payloadTypeId === 1}
                                                           onChange={() => setPayloadTypeId(1)}
                                                    />&nbsp;
                                                    <label htmlFor={"0"}
                                                           className={"m-0 p-0"}>Link&nbsp;</label>
                                                    <input type={"radio"}
                                                           name={"payloadTypeId"}
                                                           className="mt-1 my-sm-3"
                                                           value={0}
                                                           id={"0"}
                                                           checked={payloadTypeId === 0}
                                                           onChange={() => setPayloadTypeId(0)}
                                                    />&nbsp;

                                                </Col>
                                                    :
                                                    <Col>
                                                        {template && template.has_payload
                                                            ? <Tooltip title={`Attack contained a downloadable file.`}>
                                  <span className={"text-center"}>
                                    <BBIconPaperClipThin className={'text-bb-risk-low'}/>
                                      <p className={"m-0 p-0 align-self-center"}><small>Attachment</small></p>
                                  </span>
                                                            </Tooltip>
                                                            : <Tooltip title={`Attack contained a clickable link.`}>
                                  <span className={"text-center"}>
                                    <BBIconHyperlink className={'text-bb-risk-low'}/>
                                      <p className={"m-0 p-0 align-self-center"}><small>Link</small></p>
                                  </span>
                                                            </Tooltip>}
                                                    </Col>
                                                }
                                            </Row>
                                            <Row>
                                                {payloadTypeId === 1 && editMode &&
                                                <Col>
                                                    <label htmlFor={"payloadTemplate"}>Payload Template</label>
                                                    <Select className="mt-1 my-sm-3"
                                                            options={payloadTemplateOptionsArray}
                                                            name={"payloadTemplate"}
                                                            id={"payloadTemplate"}
                                                            onClick={(e)=>setPayloadTemplate(e.value)}
                                                    />
                                                </Col>}
                                            </Row>
                                        </Col>
                                        <Col>
                                            <label htmlFor={"socialThemeId"}>Theme:</label>
                                            {editMode
                                                ? <Select options={themesAsOptionsArray}
                                                    name={"socialThemeId"}
                                                    id={"socialThemeId"}
                                                    // value={"themeSelected"}
                                                    defaultValue={template && template.social_theme !== undefined
                                                        ? themesAsOptionsArray.find(x => x.value === template.social_theme)
                                                        : themesAsOptionsArray[0]}
                                                    onChange={(e)=>setSocialThemeId(e.value)}
                                                    className="mt-1 my-sm-3"/>
                                                : template
                                                && template.social_theme_details
                                                && template.social_theme_details.Name
                                                && template.social_theme_details.Description
                                                && <Tooltip title={template.social_theme_details.Description}>
                                                    <p>
                                                        {template.social_theme_details.Name}
                                                    </p>
                                            </Tooltip>
                                            }
                                        </Col>
                                        <Col>
                                            <label htmlFor={"statusId"}>Set Status:</label>
                                            {editMode
                                            ? <Select name={"statusId"}
                                                     id={"statusId"}
                                                // value={"statusId"}
                                                      defaultValue={template
                                                      && template.status
                                                          && template.status.id !== undefined
                                                          ? statusAsOptionsArray.find(x => x.value === template.status.id)
                                                          : statusAsOptionsArray[0]}
                                                     onChange={(e) => setStatusId(e.value)}
                                                     options={statusAsOptionsArray}
                                                      className="mt-1 my-sm-3"/>
                                                : template
                                                && template.status
                                                && template.status.name
                                                && template.status.description
                                                && <Tooltip title={template.status.description}>
                                                    <p>
                                                        {template.status.name}
                                                    </p>
                                            </Tooltip>
                                            }
                                        </Col>
                                    </Row>
                                </div>
                                <Row className={"m-1 p-1"}>
                                    <Col>
                                        <p>Plaintext:</p>
                                        {editMode
                                            ? <textarea className={"form-control"}
                                                    name={"plainTextMessage"}
                                                    id={"plainTextMessage"}
                                                        rows={4}
                                                        required={!viewMore}
                                                        defaultValue={template && template.plaintext_message ? template.plaintext_message : plainTextMessage}
                                                        onChange={(e)=>setPlainTextMessage(e.target.value)}
                                        />
                                            : <p>{template && template.plaintext_message ? template.plaintext_message : "N/A"}</p>
                                        }

                                    </Col>
                                </Row>
                                <Row className={"m-1 p-1"}>
                                    <Col>
                                        <p>HTML:</p>
                                        {editMode
                                            ? <textarea className={"form-control"}
                                                        name={"htmlMessage"}
                                                        id={"htmlMessage"}
                                                        rows={4}
                                                        required={!viewMore}
                                                        defaultValue={template && template.html_message ? template.html_message : htmlMessage}
                                                // placeholder={template && template.html_message ? template.html_message : "...."}
                                                        onChange={(e)=>setHtmlMessage(e.target.value)}
                                            />
                                            : <p>{template && template.html_message ? template.html_message : "N/A"}</p>
                                        }
                                    </Col>
                                </Row>
                                <div className={"card-footer"}>
                                    <Row>
                                        <Col>
                                            Optional Tags:
                                            <hr/>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <label htmlFor={"technologyTypeId"}>Tech Type <small>(optional)</small></label>
                                            {editMode
                                                ? <Select className="mt-1 my-sm-3"
                                                          options={techTypesOptionsArray}
                                                          name={"technologyTypeId"}
                                                          id={"technologyTypeId"}
                                                          onChange={(e)=>setTechnologyTypeId(e.value)}
                                                          defaultValue={template
                                                          && template.associated_technology_tag
                                                              ? techTypesOptionsArray.find(x => x.value === template.associated_technology_tag)
                                                              : techTypesOptionsArray[0]}/>
                                                :
                                                 <p className={"align-self-center mt-1 my-sm-3"}>
                                                        {template
                                                        && template.associated_technology_tag
                                                        && technologies
                                                        && technologies[template.associated_technology_tag]
                                                        && technologies[template.associated_technology_tag].name
                                                            ? technologies[template.associated_technology_tag].name
                                                            : "N/A"}
                                            </p>}
                                        </Col>
                                        <Col>
                                            <label htmlFor={"hostingProviderId"}>Hosting Provider <small>(optional)</small></label>
                                            {editMode
                                                ? <Select className="mt-1 my-sm-3"
                                                          options={hostingProvidersOptionsArray}
                                                          name={"hostingProviderId"}
                                                          id={"hostingProviderId"}
                                                          onChange={(e)=>setHostingProviderId(e.value)}
                                                          defaultValue={template
                                                          && template.associated_hosting_provider_tag
                                                              ? hostingProvidersOptionsArray.find(x => x.value === template.associated_hosting_provider_tag)
                                                              : hostingProvidersOptionsArray[0]}/>
                                                :
                                                <p className={"align-self-center mt-1 my-sm-3"}>
                                                    {template
                                                    && template.associated_hosting_provider_tag
                                                    && hostingProviders
                                                    && hostingProviders[template.associated_hosting_provider_tag]
                                                    && hostingProviders[template.associated_hosting_provider_tag].name
                                                        ? hostingProviders[template.associated_hosting_provider_tag].name
                                                        : "N/A"}
                                                </p>}
                                        </Col>
                                        <Col>
                                            <label htmlFor={"vectorTypeId"}>Associated Vector <small>(optional)</small></label>
                                            {editMode
                                                ? <Select className="mt-1 my-sm-3"
                                                          options={associatedVectorOptionsArray}
                                                          name={"vectorTypeId"}
                                                          id={"vectorTypeId"}
                                                          onChange={(e)=>setVectorTypeId(e.value)}
                                                          defaultValue={template
                                                          && template.associated_vector_definition
                                                              ? associatedVectorOptionsArray.find(x => x.value === template.associated_vector_definition)
                                                              : associatedVectorOptionsArray[0]}/>
                                                :
                                                <p className={"align-self-center mt-1 my-sm-3"}>
                                                    {template
                                                    && template.associated_vector_definition
                                                    && vectors
                                                    && vectors[template.associated_vector_definition]
                                                    && vectors[template.associated_vector_definition].name
                                                        ? vectors[template.associated_vector_definition].name
                                                        : "N/A"}
                                                </p>}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            {editMode && <Button
                                                className={"float-right"}
                                                type={"submit"}
                                                onSubmit={(data)=>onSubmit(data)}
                                                >
                                                Submit
                                            </Button>}
                                        </Col>
                                    </Row>
                                </div>
                            </form>

                        </Paper>
                </DialogContent>

                <DialogActions>
                    <Col lg={12}>
                        <Button onClick={()=>setOpen(false)}
                                variant="contained" color="primary"
                                style={{float: "right"}}>
                            Cancel
                        </Button>
                    </Col>
                </DialogActions>
            </Dialog>}

        </div>
    )

}

export default AddNewSocialTemplate